import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Redirect handler for Pocket Pay /payment/success callback
 * Pocket Pay sometimes redirects here instead of the configured return_url
 * This component looks up the booking_id from OrderId and redirects to payment-result
 */
export default function PaymentSuccessRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const lookupBookingAndRedirect = async () => {
      try {
        // Extract parameters from Pocket Pay redirect
        const orderId = searchParams.get('OrderId') || searchParams.get('order_id');
        const successIndicator = searchParams.get('successIndicator') || searchParams.get('success_indicator');
        const message = searchParams.get('Message') || searchParams.get('message');
        
        console.log('Payment success redirect params:', { orderId, successIndicator, message });
        
        if (!orderId) {
          console.error('No OrderId found in redirect');
          navigate('/bookings', { replace: true });
          return;
        }
        
        // Look up booking by Pocket Pay order ID
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${API_URL}/api/bookings/lookup-by-order/${orderId}`);
        
        if (response.ok) {
          const data = await response.json();
          const bookingId = data.booking_id;
          
          // Redirect to payment-result with all params
          const params = new URLSearchParams();
          params.append('booking_id', bookingId);
          if (orderId) params.append('OrderId', orderId);
          if (successIndicator) params.append('successIndicator', successIndicator);
          if (message) params.append('Message', message);
          
          navigate(`/payment-result?${params.toString()}`, { replace: true });
        } else {
          console.error('Failed to lookup booking by order ID');
          // Still redirect with what we have
          const params = new URLSearchParams();
          if (orderId) params.append('OrderId', orderId);
          if (successIndicator) params.append('successIndicator', successIndicator);
          if (message) params.append('Message', message);
          
          navigate(`/payment-result?${params.toString()}`, { replace: true });
        }
      } catch (error) {
        console.error('Error in payment success redirect:', error);
        navigate('/bookings', { replace: true });
      }
    };
    
    lookupBookingAndRedirect();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-gray-100 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Processing payment result...</p>
      </div>
    </div>
  );
}
